export default class SortMenu {
  title: string
  key: string
  sort: string
}
